
import { aceFrameImageSrc, type AceAvatarFrame } from '@/lib/ace-avatar-frames';
import { cn } from '@/lib/utils';
import { useState } from 'react';

type AceAvatarFramesGalleryProps = {
  frames: AceAvatarFrame[];
  className?: string;
};

function AceAvatarFrameCard({ frame }: { frame: AceAvatarFrame }) {
  const [failed, setFailed] = useState(false);

  return (
    <figure
      className={cn(
        'group overflow-hidden rounded-2xl border border-gray-200 bg-white shadow-sm transition-all duration-300',
        'hover:-translate-y-0.5 hover:border-amber-200/80 hover:shadow-md'
      )}
    >
      <div className="relative flex aspect-square items-center justify-center bg-gradient-to-br from-gray-50 to-gray-100 p-4">
        {!failed ? (
          <img
            src={aceFrameImageSrc(frame)}
            alt={`Moldura ${frame.name}`}
            className={cn(
              'max-h-full max-w-full object-contain drop-shadow-sm transition-transform duration-300 group-hover:scale-[1.03]',
              frame.shape === 'round' && 'rounded-full'
            )}
            onError={() => setFailed(true)}
          />
        ) : (
          <div
            className={cn(
              'flex h-28 w-28 items-center justify-center border-4 border-dashed border-amber-300/60 bg-amber-50/50',
              frame.shape === 'round' ? 'rounded-full' : 'rounded-2xl'
            )}
          >
            <span className="px-2 text-center font-poppins text-xs font-semibold text-amber-800">
              {frame.name}
            </span>
          </div>
        )}
        {frame.shape === 'round' ? (
          <span className="absolute right-2 top-2 rounded-full bg-violet-100 px-2 py-0.5 font-poppins text-[10px] font-semibold text-violet-700">
            Redonda
          </span>
        ) : null}
      </div>
      <figcaption className="border-t border-gray-100 px-3 py-2.5 text-center font-poppins text-sm font-semibold text-gray-800">
        {frame.name}
      </figcaption>
    </figure>
  );
}

export function AceAvatarFramesGallery({ frames, className }: AceAvatarFramesGalleryProps) {
  if (!frames.length) return null;

  return (
    <div className={cn('grid gap-4 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4', className)}>
      {frames.map((frame) => (
        <AceAvatarFrameCard key={frame.id} frame={frame} />
      ))}
    </div>
  );
}
